const WA_NUMBER = "6285311491000";

export const waLink = (message) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(message)}`;

export const WA_PLAIN = `https://wa.me/${WA_NUMBER}`;
export const WA_DISPLAY = "0853-1149-1000";

export const WA_LINK = waLink(
  "Halo Sanjaya Service, saya ingin melakukan service. Mohon informasi dan jadwal teknisi."
);

export const SERVICES = [
  {
    slug: "service-ac",
    num: "01",
    title: "Service AC",
    short: "Cuci AC, freon & perbaikan",
    icon: "Snowflake",
    desc: "Perawatan dan perbaikan AC rumah maupun kantor — cuci AC, isi/tambah freon, serta penanganan AC yang tidak dingin, kurang dingin, bocor, berisik, atau mati.",
    problems: ["AC tidak dingin / kurang dingin", "AC bocor", "AC berisik", "AC mati", "Cuci AC & isi freon"],
    waText: "Halo Sanjaya Service, saya ingin melakukan service AC. Mohon informasi dan jadwal teknisi.",
    img: "https://images.pexels.com/photos/6471913/pexels-photo-6471913.jpeg?auto=compress&cs=tinysrgb&w=800",
    price: null,
  },
  {
    slug: "service-kulkas",
    num: "02",
    title: "Service Kulkas",
    short: "Semua tipe & merek kulkas",
    icon: "Refrigerator",
    desc: "Perbaikan kulkas untuk rumah tangga dan usaha — penanganan kulkas tidak dingin, kurang dingin, bocor, mati, dan berisik, hingga masalah kompresor dan sistem pendingin.",
    problems: ["Kulkas tidak/kurang dingin", "Kulkas bocor", "Kulkas berisik", "Kulkas mati", "Masalah freon & kompresor"],
    waText: "Halo Sanjaya Service, saya ingin melakukan service kulkas. Mohon informasi dan jadwal teknisi.",
    img: "https://images.unsplash.com/photo-1571175443880-49e1d25b2bc5?auto=format&fit=crop&w=800&q=70",
    price: null,
  },
  {
    slug: "service-mesin-cuci",
    num: "03",
    title: "Service Mesin Cuci",
    short: "Semua tipe mesin cuci rumah",
    icon: "WashingMachine",
    desc: "Service mesin cuci rumah tangga semua tipe — bukaan atas, bukaan depan, 1 tabung, dan 2 tabung.",
    problems: ["Tidak berputar", "Tidak membuang air", "Bocor", "Tidak menyala", "Berisik"],
    waText: "Halo Sanjaya Service, saya ingin melakukan service mesin cuci. Mohon informasi dan jadwal teknisi.",
    img: "https://images.unsplash.com/photo-1722764375817-4f9ca20aefc1?auto=format&fit=crop&w=800&q=70",
    price: null,
  },
  {
    slug: "service-mesin-cuci-laundry",
    num: "04",
    title: "Service Mesin Cuci Laundry",
    short: "Mesin cuci komersial laundry",
    icon: "Shirt",
    desc: "Perawatan dan perbaikan mesin cuci komersial kapasitas besar untuk usaha laundry, kos, dan hotel.",
    problems: ["Tidak berputar", "Motor bermasalah", "Control/panel bermasalah", "Pompa bermasalah", "Maintenance rutin"],
    waText: "Halo Sanjaya Service, saya ingin melakukan service mesin cuci laundry. Mohon informasi dan jadwal teknisi.",
    img: "https://images.unsplash.com/photo-1545173168-9f1947eebb7f?auto=format&fit=crop&w=800&q=70",
    price: null,
  },
  {
    slug: "service-mesin-pengering-laundry",
    num: "05",
    title: "Service Mesin Pengering Laundry",
    short: "Dryer gas & listrik",
    icon: "Wind",
    desc: "Service mesin pengering (dryer) gas dan listrik untuk kebutuhan usaha laundry.",
    problems: ["Tidak panas", "Tidak berputar", "Tidak menyala", "Heater bermasalah", "Motor & control bermasalah"],
    waText: "Halo Sanjaya Service, saya ingin melakukan service mesin pengering laundry. Mohon informasi dan jadwal teknisi.",
    img: "https://images.unsplash.com/photo-1626806787461-102c1bfaaea1?auto=format&fit=crop&w=800&q=70",
    price: null,
  },
  {
    slug: "service-showcase",
    num: "06",
    title: "Service Showcase Kaca",
    short: "Display cooler untuk toko",
    icon: "GlassWater",
    desc: "Perbaikan showcase kaca dan display cooler untuk toko, warung, dan minimarket.",
    problems: ["Tidak dingin", "Suhu tidak stabil", "Bocor", "Tidak menyala", "Masalah kompresor & freon"],
    waText: "Halo Sanjaya Service, saya ingin melakukan service showcase kaca. Mohon informasi dan jadwal teknisi.",
    img: "https://images.unsplash.com/photo-1584568694244-14fbdf83bd30?auto=format&fit=crop&w=800&q=70",
    price: null,
  },
];

export const PROBLEM_CATEGORIES = [
  {
    title: "AC",
    icon: "Snowflake",
    items: ["AC tidak dingin", "AC bocor", "AC mati", "AC berisik", "AC kurang dingin", "Perlu cuci AC", "Perlu isi/tambah freon"],
  },
  {
    title: "Kulkas",
    icon: "Refrigerator",
    items: ["Kulkas tidak dingin", "Kulkas bocor", "Kulkas berisik", "Kulkas mati", "Masalah freon", "Masalah kompresor"],
  },
  {
    title: "Mesin Cuci",
    icon: "WashingMachine",
    items: ["Tidak berputar", "Tidak membuang air", "Bocor", "Tidak menyala", "Berisik"],
  },
  {
    title: "Mesin Cuci Laundry",
    icon: "Shirt",
    items: ["Tidak berputar", "Motor bermasalah", "Control/panel bermasalah", "Pompa bermasalah", "Membutuhkan maintenance"],
  },
  {
    title: "Mesin Pengering Laundry",
    icon: "Wind",
    items: ["Tidak panas", "Tidak berputar", "Tidak menyala", "Heater bermasalah", "Motor bermasalah", "Control bermasalah"],
  },
  {
    title: "Showcase",
    icon: "GlassWater",
    items: ["Tidak dingin", "Suhu tidak stabil", "Bocor", "Tidak menyala", "Masalah kompresor", "Masalah freon"],
  },
];

export const WHY_US = [
  {
    icon: "BadgeCheck",
    title: "Teknisi Berpengalaman",
    desc: "Ditangani teknisi yang terbiasa memperbaiki peralatan rumah tangga dan mesin laundry.",
  },
  {
    icon: "Truck",
    title: "Datang ke Lokasi",
    desc: "Pengerjaan dilakukan di rumah, toko, atau tempat usaha Anda.",
  },
  {
    icon: "ReceiptText",
    title: "Harga Transparan",
    desc: "Estimasi biaya disampaikan dengan jelas sebelum pengerjaan dimulai.",
  },
  {
    icon: "Wrench",
    title: "Pengerjaan Profesional",
    desc: "Diagnosa teliti, dan hasil perbaikan ditest sebelum dinyatakan selesai.",
  },
  {
    icon: "Home",
    title: "Melayani Rumah Tangga & Bisnis",
    desc: "Rumah tangga, usaha laundry, hingga toko dengan peralatan pendingin.",
  },
  {
    icon: "MessageCircle",
    title: "Respon Cepat melalui WhatsApp",
    desc: "Cukup satu chat untuk bertanya dan menjadwalkan teknisi.",
  },
];

export const JAKARTA_AREAS = [
  { name: "Jakarta Pusat", slug: "jakarta-pusat" },
  { name: "Jakarta Barat", slug: "jakarta-barat" },
  { name: "Jakarta Selatan", slug: "jakarta-selatan" },
  { name: "Jakarta Timur", slug: "jakarta-timur" },
  { name: "Jakarta Utara", slug: "jakarta-utara" },
];

export const OTHER_AREAS = [
  { name: "Bekasi", slug: "bekasi", active: true },
  { name: "Depok", slug: "depok", active: true },
  { name: "Bogor", slug: "bogor", active: false },
  { name: "Tangerang", slug: "tangerang", active: false },
  { name: "Tangerang Selatan", slug: "tangerang-selatan", active: false },
];

export const FAQS = [
  {
    q: "Berapa biaya service AC?",
    a: "Biaya service tergantung jenis pengerjaan dan kondisi unit. Hubungi kami melalui WhatsApp untuk mendapatkan estimasi biaya sebelum teknisi datang.",
  },
  {
    q: "Apakah teknisi bisa datang ke lokasi?",
    a: "Ya, teknisi kami datang langsung ke lokasi Anda — baik rumah, kantor, toko, maupun tempat usaha laundry.",
  },
  {
    q: "Apakah melayani service AC Jakarta Barat?",
    a: "Ya. Kami melayani seluruh wilayah Jakarta, termasuk Jakarta Barat, Pusat, Selatan, Timur, dan Utara, serta area sekitarnya seperti Bekasi dan Depok.",
  },
  {
    q: "Apakah melayani service AC Jakarta Selatan?",
    a: "Ya, Jakarta Selatan termasuk dalam area layanan kami. Silakan hubungi kami via WhatsApp untuk mengatur jadwal teknisi.",
  },
  {
    q: "Apakah melayani service AC Jakarta Pusat?",
    a: "Ya, kami melayani service AC di Jakarta Pusat dan seluruh wilayah Jakarta lainnya. Teknisi datang ke lokasi Anda sesuai jadwal yang disepakati.",
  },
  {
    q: "Apakah melayani service kulkas Jakarta Barat?",
    a: "Ya, kami melayani perbaikan kulkas di Jakarta Barat — seperti kulkas tidak dingin, bocor, atau masalah kompresor. Hubungi kami via WhatsApp untuk jadwal teknisi.",
  },
  {
    q: "Apakah melayani service kulkas Jakarta Selatan?",
    a: "Ya, pelanggan di Jakarta Selatan dapat memesan service kulkas melalui WhatsApp. Teknisi kami datang ke lokasi untuk pemeriksaan dan perbaikan.",
  },
  {
    q: "Apakah melayani service kulkas?",
    a: "Ya, kami menangani berbagai masalah kulkas seperti tidak dingin, bocor, berisik, mati total, hingga masalah freon dan kompresor.",
  },
  {
    q: "Apakah melayani mesin cuci laundry?",
    a: "Ya, kami melayani perbaikan dan perawatan mesin cuci komersial untuk usaha laundry, termasuk masalah motor, panel kontrol, dan pompa.",
  },
  {
    q: "Apakah melayani mesin pengering laundry?",
    a: "Ya, kami menangani mesin pengering (dryer) gas maupun listrik — seperti tidak panas, tidak berputar, serta masalah heater, motor, dan control.",
  },
  {
    q: "Apakah melayani service showcase kaca?",
    a: "Ya, kami melayani perbaikan showcase kaca dan display cooler untuk toko dan usaha, seperti tidak dingin, suhu tidak stabil, atau bocor.",
  },
  {
    q: "Berapa lama proses service?",
    a: "Lama pengerjaan tergantung jenis kerusakan. Sebagian besar perbaikan dapat diselesaikan di lokasi pada kunjungan yang sama.",
  },
  {
    q: "Bagaimana cara memesan teknisi?",
    a: "Cukup klik tombol WhatsApp di halaman ini, jelaskan masalah peralatan Anda, dan kami akan mengatur jadwal teknisi ke lokasi Anda.",
  },
];

export const GALLERY = [
  {
    title: "Service Mesin Cuci",
    img: "images/gallery/mesin-cuci-1.jpg",
    alt: "Mesin cuci front loading dibongkar untuk diperbaiki Sanjaya Service",
  },
  {
    title: "Service Mesin Cuci",
    img: "images/gallery/mesin-cuci-2.jpg",
    alt: "Mesin cuci dua tabung dibongkar, terlihat motor dan gearbox",
  },
  {
    title: "Service Kulkas",
    img: "images/gallery/kulkas-1.jpg",
    alt: "Kulkas dua pintu pelanggan yang ditangani Sanjaya Service",
  },
  {
    title: "Mesin Laundry",
    img: "images/gallery/laundry-1.jpg",
    alt: "Mesin cuci dan mesin pengering laundry di area kerja",
  },
  {
    title: "Pengerjaan di Lokasi",
    img: "images/gallery/lokasi-1.jpg",
    alt: "Teknisi mengerjakan perbaikan unit di lokasi pelanggan",
  },
  {
    title: "Teknisi",
    img: "https://images.pexels.com/photos/6471913/pexels-photo-6471913.jpeg?auto=compress&cs=tinysrgb&w=600",
    alt: "Teknisi Sanjaya Service memeriksa tekanan freon pada unit AC",
  },
  {
    title: "Service AC",
    img: "https://images.pexels.com/photos/12687438/pexels-photo-12687438.jpeg?auto=compress&cs=tinysrgb&w=600",
    alt: "Unit AC outdoor pada dinding gedung yang diservice",
  },
  {
    title: "Showcase",
    img: "https://images.unsplash.com/photo-1584568694244-14fbdf83bd30?auto=format&fit=crop&w=600&q=60",
    alt: "Showcase kaca display minuman di toko",
  },
];

// Isi dengan { quote, name, meta } saat testimoni asli dari pemilik usaha tersedia.
export const TESTIMONIALS = [];
